import type { CreateSlice } from './index'

export interface CalculadoraState {
    isCalculadoraAberta: boolean
    abrirCalculadora: () => void
    fecharCalculadora: () => void
}

export const createCalculadoraSlice: CreateSlice<CalculadoraState> = set => ({
    isCalculadoraAberta: false,
    abrirCalculadora: () => set({ isCalculadoraAberta: true }),
    fecharCalculadora: () => set({ isCalculadoraAberta: false }),
})
